export default "__VITE_ASSET__c0950476__"